import React from 'react';

const NoMatch = () => <div className="notFound">Page not found</div>;

export default NoMatch;
